import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
import { ReactComponent as iIcon } from "../../assets/images/iIcon.svg";
import { ReactComponent as DangerCircle } from "../../assets/images/DangerCircle.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrganisation } from "../../reduxSlices/organisationSlice";
import {
  BASE_URL,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import { IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Loader from "../../components/loader/Loader";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import SearchBar from "../../components/searchBar/SearchBar";
import CommonDropdown from "../../components/dropdown/CommonDropdown";
import TopBar from "../../components/topbar/TopBar";
import { getAllVfUsers } from "../../reduxSlices/vfuserSlice";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { toast } from "react-toastify";
import { Service } from "../../services/service";
import CommonDialog from "../../components/dialog/CommonDialog";
import NoResultFound from "../../components/noResultFound/NoResultFound";

const service = new Service();

const columns = [
  { id: "name", label: "Name", minWidth: 170, align: "left" },
  { id: "email", label: "Email", minWidth: 170, align: "left" },
  { id: "status", label: "Status", minWidth: 170, align: "left" },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

export default function VFUserPage() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userId, setUserId] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const allVfUsers = useSelector((state) => state.vfuser.allVfUsers);
  const loading = useSelector((state) => state.vfuser.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  const organisationsValue = headerData.organisationsValue;
  const reports = headerData.reports;
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID) ? true : false;

  const handleMoreIcon = (event, data) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setUserId(data?.userId);
    setData(data);
  };

  const getVfUserData = async () => {
    const obj = {
      searchText: searchInput || "",
    };
    await dispatch(getAllVfUsers(obj));
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "vfusers",
        title: "Visualise Users",
        subTitle:
          "Here is the list of all visualise users along with their details",
      })
    );
  }, []);

  useEffect(() => {
    getVfUserData();
  }, [dispatch]);

  const getVfUserDataWithDebounce = debounce(() => {
    getVfUserData();
  }, 500);

  const searchInputDebounceLoadData = useCallback(
    debounce(getVfUserDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (userId) {
      console.log("id>>>>>>>", userId);
      deleteVfUser(userId);
      setOpen(false);
    }
  };

  const deleteVfUser = async (id) => {
    let url = `/api/User/DeleteUser?id=${id}&isDelete=${open}&isVFAdmin=${isVfAdmin}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success(
          !open
            ? `User marked as ${data?.isActive ? "Inactive" : "Active"}`
            : `User has been deleted`,
          {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          }
        );
        getVfUserData();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar isVfAdmin={isVfAdmin} clearFilter={false} placeholder="Search Visualise users here..." />
        {loading && allVfUsers.length === 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{ maxHeight: "calc(100vh - 320px)", padding: "0 0" }}
            className="table_container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#fff",
                        color: "#8a8a8a",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allVfUsers.length > 0 ? (
                  <>
                    {allVfUsers?.map((elem) => (
                      <TableRow hover key={elem.organizationId}>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#282828",
                            fontWeight: 600,
                          }}
                        >
                          {elem?.givenName || ""} {elem?.familyName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.emailId || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.isActive ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          align="center"
                        >
                          <MoreIcon onClick={(e) => handleMoreIcon(e, elem)} />
                        </TableCell>
                      </TableRow>
                    ))}
                    <ActionDropdown
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      editNavigate={`/edit-vfuser/${userId}`}
                      setOpen={setOpen}
                      isDelete={true}
                      isActive={true}
                      text={`Mark as ${data?.isActive ? "Inactive" : "Active"}`}
                      markAsActiveInactive={handleDelete}
                    />
                  </>
                ) : (
                  <NoResultFound
                    description="We couldn’t find any matches for search query or applied filter. Please try different
                  keyword or filters."
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle={`Are you sure you want to delete <span style="font-weight: 700;">${data?.givenName} ${data?.familyName}</span> as an user? You’ll not be able to reverse this action.`}
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
    </>
  );
}
